module.exports = __webpack_public_path__ + "img/traefik.5751579d.png";